<template>
  <div class="search-wrapper">
    <span v-if="status === 'primeval'" class="primeval-search-btn" @click="changeSearchStatus"></span>
    <div v-if="status === 'selected'" class="selected-search-wrapper">
      <div class="selected-search-bar">
        <span class="search-return-btn" @click="changeSearchStatus"></span>
        <input class="search-input" :placeholder="searchBtnText" type="text" v-model="searchValue" />
        <span class="search-btn" @click="handleClickSearchBtn">搜索</span>
      </div>
      <div class="selected-search-list" v-if="searchResultList.length > 0">
        <div class="selected-search-item" v-for="(item, index) in searchResultList" :key="index" @click="handleItem(item)">
          <span class="classic-name">{{ item.classicName }}</span>
          <span class="main-name">{{ item.name }}</span>
        </div>
      </div>
      <div class="selected-search-list" v-if="searchResultList.length === 0 && hasClickSearch">
        暂无搜索内容
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { getSearchResult } from '@/server/interfaces'
import { buryingPoint } from '@/utils/buryingPoint'

export default {
  data () {
    return {
      status: 'primeval', // primeval, selected
      searchValue: '',
      searchResultList: undefined,
      hasClickSearch: false
    }
  },
  props: {
    handleSelectStore: {
      type: Function,
      default: () => {}
    },
    handleSelectRoute: {
      type: Function,
      default: () => {}
    },
    searchBtnText: {
      type: String,
      default: '搜索'
    }
  },
  computed: {
    ...mapGetters({
      activityId: 'activityInfo/activityId'
    })
  },
  methods: {
    ...mapMutations({
      toast: 'toast/showToast',
      showLoading: 'loading/showLoading',
      hideLoading: 'loading/hideLoading'
    }),
    changeSearchStatus () {
      buryingPoint({ action: this.status === 'selected' ? 33 : 32 , sourceTag: 2, activityId: this.activityId, itemType: 2 })
      this.initData()
      if (this.status === 'selected') this.status = 'primeval'
      else if (this.status === 'primeval') this.status = 'selected'
    },
    async handleClickSearchBtn () {
      buryingPoint({ action: 34, sourceTag: 2, activityId: this.activityId, itemType: 2 })
      if (this.searchValue.trim() === '') {
        this.toast('请先输入搜索内容')
        return
      }
      this.searchResultList = []
      const params = {
        activityId: this.activityId,
        searchText: this.searchValue
      }
      this.showLoading()
      const res = await getSearchResult({ params })
      console.log('handleClickSearchBtn', res)
      this.hideLoading()
      if (res) {
        this.searchResultList = this.searchResultList
          .concat(
            (res.lines ? res.lines : []).map(item => {
              item.classicName = '红色路线'
              item.isLines = true
              return item
            })
          )
          .concat(
            (res.stores ? res.stores : []).map(item => {
              item.classicName = item.cateName
              item.isLines = false
              return item
            })
          )
        this.hasClickSearch = true
      } else {
        this.toast('搜索失败，请稍后再试')
      }
    },
    handleItem (item) {
      buryingPoint({ action: 35, sourceTag: 2, activityId: this.activityId, itemType: 2 })
      item.isLines && this.selectLineItem(item)
      !item.isLines && this.selectStoresItem(item)
      this.initData()
      this.status = 'primeval'
    },
    selectLineItem (item) {
      console.log('selectLineItem, 点击line不太一样的地方')
      this.handleSelectRoute(item.uid)
    },
    selectStoresItem (item) {
      console.log('selectStoresItem, 点击store不太一样的地方', item)
      this.handleSelectStore(item.id)
    },
    initData () {
      this.searchValue = ''
      this.searchResultList = []
      this.hasClickSearch = false
    }
  }
}
</script>

<style lang="scss" scoped>
.search-wrapper {
  width: 0.7rem;
  line-height: 0.7rem;
  position: fixed;
  top: 0.95rem;
  left: 0.2rem;
  z-index: 1001;
  .primeval-search-btn {
    width: 0.7rem;
    height: 0.7rem;
    display: inline-block;
    border-radius: 50%;
    background: url(../../../../assets/images/icon_search.png) center no-repeat;
    background-size: 0.33rem;
    background-color: #fff;
    box-shadow: 0 4px 8px 0 rgba(113, 108, 98, 0.25);
  }
  .selected-search-wrapper {
    .selected-search-bar {
      width: calc(100vw - 0.4rem);
      height: 0.76rem;
      background: #ffffff;
      box-shadow: 0 4px 8px 0 rgba(113, 108, 98, 0.2);
      border-radius: 0.38rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .search-return-btn {
        display: inline-block;
        width: 0.8rem;
        height: 0.34rem;
        border-right: 1px solid #d8d8d8;
        margin-right: 0.25rem;
        background: url(../../../../assets/images/icon_back.png) center no-repeat;
        background-size: 0.34rem;
      }
      .search-input {
        width: 4.55rem;
        height: 0.56rem;
        line-height: 0.56rem;
        font-size: 0.28rem;
        color: #333333;
        border: 0;
      }
      .search-btn {
        display: inline-block;
        width: 1.04rem;
        height: 0.64rem;
        line-height: 0.64rem;
        text-align: center;
        background-image: linear-gradient(180deg, #ff601a 0%, #dc0808 100%);
        border-radius: 0.38rem;
        color: #fff;
        font-size: 0.28rem;
      }
    }
    .selected-search-list {
      width: calc(100vw - 0.4rem);
      max-height: 5.97rem;
      overflow-y: scroll;
      background: #ffffff;
      box-shadow: 0 4px 8px 0 rgba(113, 108, 98, 0.2);
      border-radius: 0.14rem;
      padding: 0.3rem 0.35rem;
      font-size: 0.28rem;
      color: #333333;
      margin-top: 0.1rem;
      .selected-search-item {
        display: flex;
        align-items: center;
        height: 0.7rem;
        .classic-name {
          display: inline-block;
          color: #666;
          width: 1.22rem;
          height: 0.7rem;
          margin-right: 0.3rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .main-name {
          display: inline-block;
          width: 4.98rem;
          height: 0.7rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
